/**
 * Remington 870. 12 gauge pump: nine pellets a shell, fed one shell at a time, so it exercises
 * both branches of the reload machine.
 */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const REMINGTON870 = {
  id: 'remington870',
  label: 'Remington 870',
  classId: 'shotgun',
  caliber: '12 gauge',
  fireMode: 'pump',
  roundsPerMinute: 90,
  magSize: 6,
  reserveAmmo: 36,
  reloadSeconds: 0.55,
  emptyReloadSeconds: 0.55,
  reloadStyle: 'shell',
  damage: 12,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 12, zeroMetres: 45, minScale: 0 },
  pellets: 9,
  adsSpreadMoa: 90,
  hipSpreadMoa: 180,
  bloomMoaPerShot: 0,
  bloomMoaCap: 0,
  bloomDecayMoaPerSecond: 0,
  moveSpreadMoaPerMps: 10,
  crouchSpreadScale: 0.8,
  airborneSpreadMoa: 40,
  recoilPattern: [
    { pitch: 2.6, yaw: 0.18 },
    { pitch: 2.55, yaw: -0.22 },
  ],
  recoilResetSeconds: 0.8,
  recoilRecoveryPerSecond: 5,
  adsFovDegrees: 62,
  adsSeconds: 0.28,
  adsSensitivityScale: 0.85,
  muzzleVelocity: 400,
} as const satisfies WeaponSpec;
